import React from 'react';
import PlanPromoPage from './PlanPromoPage';
import image from './assets/check-in@2x.png';
import { push, Routes } from 'routing';
import { useTranslation } from 'services/localization';
import { Typography } from '@mui/material';

const CheckInPromoPage = () => {
	const { t } = useTranslation();
	const description = (
		<>
			<Typography variant="body1" sx={{ mb: 3 }}>
				{t(
					'promoPages.checkIn.description1',
					'Get faster in-store bookings and make your customers happier.',
				)}
			</Typography>
			<Typography variant="body1" sx={{ mb: 3 }}>
				{t(
					'promoPages.checkIn.description2',
					'Upgrade to Rentle Advanced to start using Check-In.',
				)}
			</Typography>
		</>
	);
	return (
		<PlanPromoPage
			tag={t('promoPages.checkIn.tag', 'Check-In App')}
			title={t('promoPages.checkIn.title', 'The in-store solution for your retail business')}
			description={description}
			image={image}
			primaryCta={{
				text: t('account.stores.upgradePlan', 'Upgrade plan'),
				onClick: () => push(Routes.PlanConfirm('ADVANCED')),
				requiredFeature: 'PLAN_BILLING',
			}}
			secondaryCta={{
				text: t('homeView.bookADemo', 'Book a demo'),
				onClick: () => window.open('https://www.rentle.io/demo', '_blank'),
			}}
		/>
	);
};

export default CheckInPromoPage;
